// extracted by mini-css-extract-plugin
export default {"root":"ClientInfo_root__RSmQ+"};